export default __webpack_public_path__ + "static/23-608b26f0f90b06de78307776ca293dbb.png";